import React, { useState, useEffect, useRef } from 'react'

import {

    Button, Dialog, Grid, Icon, RadioGroup,
    Typography, Input, FormHelperText, FormControl,
    FormGroup, FormControlLabel, Checkbox, Radio, Select, FormLabel
} from '@material-ui/core'

import FileSaver from 'file-saver';


import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '../../../assets/img/icons/binIcon.png';
import RichTextEditor from 'react-rte';
import { InputBaseField, SelectField, TextareaField } from '../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "../../../components/Message/Alert";
import { lstStates, lstCountry, lstMonths, documentType, sheilaProgramPlans } from '../../../../src/components/Common/Lookup';
import useStyles from "./styles";
import { validateEmail, validatePhoneNumber, allowedAttachmentsImages, handleNumberKeyPress, formatDateYMD, formatDate, formatTime, formatDateTime, toCamelCase } from '../../../../src/components/Common/Extensions';
import PreviewPhoto from '../../../assets/img/common/Loren-Solorzano-identity.jpg';
import askForReview from '../../../assets/img/common/askForReview.png';
import AskForReviewStar from '../../../assets/img/common/askForReviewStar.gif';
import axios from 'axios';
import DialogLoader from '../../../components/Loader/DialogLoader';
import ImageCropModal from './cropImg/ImageCrop';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import CropDemo from './cropImg/CropExample';
import { ActionDialog } from "../../../components/ActionDialog/ActionDialog";
import { HealthcareTabletProgram, HealthcareFloridaConnectApplyFor } from '../../../../src/components/Common/AppEnums';


function AddProgram({ dialogOpenClose, handleClose, handleSuccessClose, record, program, ...props }) {
    const classes = useStyles();
    const commonAttachments = allowedAttachmentsImages();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ deliveryDate: formatDateYMD(new Date()), deliveryTime: formatTime(new Date()), receiverType: 'Self', collectedBy: '', program: HealthcareTabletProgram.FloridaConnect, applyFor: [] });
    const { showMessage } = props;
    const [identityImage, setIdentityImage] = useState({ file: null, fileToSend: null, fileName: null });
    const [pictureReceivingPhone, setPictureReceivingPhone] = useState({ file: null, fileToSend: null, fileName: null });
    const [identityGuardianImage, setIdentityGuardianImage] = useState({ file: null, fileToSend: null, fileName: null });
    const [isReviewLinksVisible, setIsReviewLinksVisible] = useState(false);
    const [matchingChildrenWithParent, setMatchingChildrenWithParent] = useState([]);
    const [skipDeviceInfo, setSkipDeviceInfo] = useState(false);

    //const defaultProgramBeneficiariesList = [{ beneficiaryId: 0, firstName: '', lastName: '', ssn: '', dateOfBirth: '', hasIep:false, isDeleted: false },
    //    { beneficiaryId: 0, firstName: '', lastName: '', ssn: '', dateOfBirth: '', hasIep: false, isDeleted: false }
    //];

    const [beneficiariesList, setBeneficiariesList] = useState([{ beneficiaryId: 0, firstName: '', lastName: '', ssn: '', dateOfBirth: '', hasIep: false, isDelivered: true, isDeleted: false }]);

    const handleAddBeneficiaryItem = () => {
        var listCount = beneficiariesList.filter(t => !t.isDeleted).length;
        if (listCount == 20) {
            showMessage("Error", "A maximum of 20 childs can be added", "error", 3000);
        } else {
            var newObj = { beneficiaryId: 0, firstName: '', lastName: '', ssn: '', dateOfBirth: '', hasIep: false, isDelivered: true, isDeleted: false };
            setBeneficiariesList([...beneficiariesList, newObj]);
        }

    };

    const handleDeleteBeneficiaryItem = (item, index) => {
        //   showActionDialog("Are you sure you want to delete this child?", "confirm", function () {
        if (item.beneficiaryId > 0) {
            showMessage("Warning", "Cannot delete the child as their device is selected for delivery.", "warning", 3000);
            return;
        }
        const beneficiaryItems = [...beneficiariesList];
        beneficiaryItems.splice(index, 1);
        setBeneficiariesList(beneficiaryItems);
        //});
        //if (item.beneficiaryId <= 0) {
        //    const beneficiaryItems = [...beneficiariesList];
        //    beneficiaryItems.splice(index, 1);
        //    setBeneficiariesList(beneficiaryItems);
        //} else {
        //    const updatedArray = beneficiariesList.map((obj, i) => {
        //        if (obj.beneficiaryId === item.beneficiaryId) {
        //            return { ...obj, isDeleted: true };
        //        }
        //        return obj;
        //    });
        //    setBeneficiariesList(updatedArray);
        //}
    };


    const isGuardianInputsDisabled = () => {

        return false;//state?.receiverType == 'SocialWorker' && state?.selectedSocialWorker ? true : false
    }

    const [fileUrl, setFileUrl] = useState(null);
    const [fieldName, setFieldName] = useState(null);
    const [cropImagedialog, setCropImageDialog] = useState(false);
    const [isSIMActivationEnabled, setIsSIMActivationEnabled] = useState(false);


    const handleFileChange = (e) => {
        openCropImage()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            const url = URL?.createObjectURL(selectedFile);
            setFileUrl(url);
            setFieldName(e.target)
        }

    }

    const openCropImage = () => {
        setCropImageDialog(true)
    }

    const closeCropImage = () => {
        fieldName.value = ""
        setCropImageDialog(false)
    }

    const onSave = async (croppedImage, fieldName) => {

        const name = fieldName.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        if (fieldName.name === 'proofOfIdentity') {
            setIdentityImage({
                file: croppedImage,
                fileToSend: croppedImage,
                fileName: fieldName.files[0].name
            })
        } else if (fieldName.name === 'pictureReceiving') {
            setPictureReceivingPhone({
                file: croppedImage,
                fileToSend: croppedImage,
                fileName: fieldName.files[0].name
            })
        }
        else if (fieldName.name === 'identityGuardianImage') {
            setIdentityGuardianImage({
                file: croppedImage,
                fileToSend: croppedImage,
                fileName: fieldName.files[0].name
            })
        }
        setTimeout(() => {
            setCropImageDialog(false)
        })
    };

    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        if (e.target.name == 'proofOfIdentity') {
            setIdentityImage({
                file: URL.createObjectURL(e.target.files[0]),
                fileToSend: e.target.files[0],
                fileName: e.target.files[0].name
            })
        } else if (fieldName.name === 'pictureReceiving') {
            setPictureReceivingPhone({
                file: URL.createObjectURL(e.target.files[0]),
                fileToSend: e.target.files[0],
                fileName: e.target.files[0].name
            })
        }
        else if (fieldName.name === 'identityGuardianImage') {
            setIdentityGuardianImage({
                file: URL.createObjectURL(e.target.files[0]),
                fileToSend: e.target.files[0],
                fileName: e.target.files[0].name
            })
        }

    }

    const inputFile = useRef(null);

    const uploadFile = () => {

        inputFile.current.click();
    };

    const [selectedOption, setSelectedOption] = useState('SSN');

    //const [selectChildStatus, setSelectChildStatus] = useState(HealthcareFloridaConnectApplyFor.Self);



    const changeIdentityOption = (event) => {
        const { name, value } = event.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }
    const [selectedSocialWorker, setSelectedSocialWorker] = useState({});
    const handleSocialWorkerSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))

        if (value !== '') {
            const selectedWorker = socialWorkersList.find(sw => sw.socialWorkerId == value);
            //showSocialWorkerOnUI
            setSelectedSocialWorker(selectedWorker);
            //loadSocialWorkerRecord(selectedWorker);
        } else {
            setSelectedSocialWorker({});
            //setState(prevState => ({
            //    ...prevState,
            //    'guardianFullName': '',
            //    'guardianDOB': '',
            //    'guardianEmail': '',
            //    'guardianPhone': '',
            //    'guardianSSN': '',
            //    'documentGuardianType': '',
            //    'identityGuardianImagePath': '',
            //    'identityGuardianImageFileName': '',
            //    'agencyName': '',
            //    'agencyLicense': '',
            //}));
            //setIdentityGuardianImage({
            //    file: '',
            //    fileToSend: '',
            //    fileName: ''
            //})
        }

    }

    const loadSocialWorkerRecord = (selectedWorker) => {
        var params1 = {
            socialWorkerName: selectedWorker.param1,
            SocialWorkerAgency: selectedWorker.param2
        };
        PostDataAPI("fdnmcchromicconnect/getSocialWorkerRecord", params1).then((result) => {
            if (result.success && result.data != null) {
                setState(prevState => ({
                    ...prevState,
                    'guardianFullName': result.data.guardianFullName,
                    'guardianDOB': result.data.guardianDOB ? result.data.guardianDOB.split('T')[0] : '',
                    'guardianEmail': result.data.guardianEmail,
                    'guardianPhone': result.data.guardianPhone,
                    'guardianSSN': result.data.guardianSSN,
                    'documentGuardianType': result.data.documentGuardianType,
                    'identityGuardianImagePath': result.data.identityGuardianImagePath,
                    'identityGuardianImageFileName': result.data.identityGuardianImageFileName,
                    'agencyName': result.data.agencyName,
                    'agencyLicense': result.data.agencyLicense,
                }));
                setIdentityGuardianImage({
                    file: '',
                    fileToSend: '',
                    fileName: result.data.identityGuardianImageFileName
                })
                //debugger;
            }
        })
    }
    const handleChange = e => {
        const { name, value } = e.target;

        if (value.trim() === "" && value !== "") {
            return;
        }

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [isBeneficiaryChanged, setIsBeneficiaryChanged] = useState(false);
    const handleBeneInputChange = (e, index) => {
        const { name, value } = e.target;

        const newInputs = [...beneficiariesList];

        if (name == 'hasIep') {
            newInputs[index][name] = e.target.checked;
        } else {
            newInputs[index][name] = value;
        }

        setBeneficiariesList(newInputs);
        setIsBeneficiaryChanged(true);
    };

    //const handleSelectDelivered = (event, index) => {
    //    const { checked } = event.target;

    //    setBeneficiariesList((prevList) =>
    //        prevList.map((child, i) =>
    //            i === index ? { ...child, isDelivered: checked } : child
    //        )
    //    );
    //    console.log(beneficiariesList)
    //};
    const handleSelectDelivered = (event, index) => {
        const { checked } = event.target;

        setBeneficiariesList((prevList) => {
            // Count how many items are currently marked as delivered
            const deliveredCount = prevList.filter((child) => child.isDelivered).length;

            // Show alert and prevent unchecking the last 'isDelivered' item
            if (!checked && deliveredCount === 1 && prevList[index].isDelivered) {
                showMessage("Warning", "At least one device is required for delivery.", "warning", 3000);
                return prevList; // Do nothing
            }

            // Update the selected item's 'isDelivered' status
            return prevList.map((child, i) =>
                i === index ? { ...child, isDelivered: checked } : child
            );
        });
    };



    const handleZipCodeChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
        if (value.trim() != '' && value.trim().length > 4) {
            getStateAndCityOnZipCodeChange(value);
        }

    };
    const removeSpacesFromKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const newKey = key.replace(/\s/g, '_');
            newObj[newKey] = obj[key];
        });
        return newObj;
    };
    const getStateAndCityOnZipCodeChange = (zipCode) => {
        axios
            .get(`https://api.zippopotam.us/us/${zipCode}`)
            .then((response) => {
                if (response.data != null && response.data.places != null && response.data.places.length > 0) {

                    const { state, state_abbreviation, place_name } = removeSpacesFromKeys(response.data.places[0]);

                    setState(prevState => ({
                        ...prevState,
                        ['state']: state_abbreviation,
                        ['city']: place_name
                    }))
                }
            })
            .catch((error) => {
                //console.log('Error fetching location data:', error);
            });
    };

    const [isData, setIsData] = useState(false);

    const handlePhoneChange = (e) => {
        const { name, value } = e.target;

        if (e.target.value != "") {
            const re = /^[0-9\b]+$/;
            e.target.value = e.target.value
                .replace(" ", "")
                .replace("(", "")
                .replace(")", "")
                .replace("-", "");
            const { name, value } = e.target;
            if (e.target.value === "" || re.test(e.target.value)) {
                var cleaned = ("" + e.target.value).replace(/\D/g, "");
                var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                    var intlCode = match[1] ? "+1 " : "",
                        number = [
                            intlCode,
                            "(",
                            match[2],
                            ") ",
                            match[3],
                            "-",
                            match[4],
                        ].join("");

                    setState((prevState) => ({
                        ...prevState,
                        [name]: number,
                    }));
                    return;
                }
                setState((prevState) => ({
                    ...prevState,
                    [name]: value,
                }));
            } else {
                if (!re.test(e.target.value)) {
                    e.preventDefault();
                }
            }
        } else {
            setState((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };
    const handleGuardianPhoneChange = (e) => {
        const { name, value } = e.target;

        if (e.target.value != "") {
            const re = /^[0-9\b]+$/;
            e.target.value = e.target.value
                .replace(" ", "")
                .replace("(", "")
                .replace(")", "")
                .replace("-", "");
            const { name, value } = e.target;
            if (e.target.value === "" || re.test(e.target.value)) {
                var cleaned = ("" + e.target.value).replace(/\D/g, "");
                var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                    var intlCode = match[1] ? "+1 " : "",
                        number = [
                            intlCode,
                            "(",
                            match[2],
                            ") ",
                            match[3],
                            "-",
                            match[4],
                        ].join("");

                    setState((prevState) => ({
                        ...prevState,
                        [name]: number,
                    }));
                    return;
                }
                setState((prevState) => ({
                    ...prevState,
                    [name]: value,
                }));
            } else {
                if (!re.test(e.target.value)) {
                    e.preventDefault();
                }
            }
        } else {
            setState((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const [errorMessages, setErrorMessages] = useState({});
    const [errorChildMessages, setErrorChildMessages] = useState({});

    const genderChange = (e) => {
        const { name, value } = e.target;

        setState(prevState => ({
            ...prevState,
            name: value
        }))
    }

    function toDayDate() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        return today;
    }
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    });
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const checkForUniqueBeneficiaries = (validBeneficiaries) => {
        const seen = new Set();

        for (let i = 0; i < validBeneficiaries.length; i++) {
            const beneficiary = validBeneficiaries[i];

            if (!beneficiary.firstName || !beneficiary.lastName || !beneficiary.ssn || !beneficiary.dateOfBirth) {
                continue;
            }

            const uniqueKey = `${beneficiary.firstName.trim()}_${beneficiary.lastName.trim()}_${beneficiary.ssn.trim()}_${beneficiary.dateOfBirth}`;
            if (seen.has(uniqueKey)) {
                return false;
            }
            seen.add(uniqueKey);
        }

        return true;
    };

    const validateChild = (errorList) => {
        setMatchingChildrenWithParent([]);
        const validBeneficiaries = beneficiariesList.filter(beneficiary => !beneficiary.isDeleted);

        if ((!validBeneficiaries || validBeneficiaries.length <= 0) && state.applyFor.includes("other")) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddChildInfor: true
            }));

            errorList.push(true);

        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddChildInfor: false
            }));

        }
        if (validBeneficiaries && validBeneficiaries.length > 0) {
            let errorChildList = [];
            validBeneficiaries.forEach((child, index) => {
                var isChildNotValidated = validateChildInformation(index)
                if (isChildNotValidated) {
                    errorChildList.push(true);
                }
            });

            if (errorChildList.length <= 0) {
                const matchingChildrenIndexes = [];

                if (state.firstName && state.lastName && state.dateOfBirth && state.ssn) {
                    validBeneficiaries.forEach((child, index) => {
                        //check if any child info match to parent info
                        if (
                            child.firstName.trim() === state.firstName.trim() &&
                            child.lastName.trim() === state.lastName.trim() &&
                            child.dateOfBirth === state.dateOfBirth &&
                            child.ssn.trim() === state.ssn.trim()
                        ) {
                            matchingChildrenIndexes.push(index);
                        }
                    });
                    setMatchingChildrenWithParent(matchingChildrenIndexes);
                }

                if (matchingChildrenIndexes.length > 0) {
                    errorList.push(true);
                } else if (!checkForUniqueBeneficiaries(validBeneficiaries)) {
                    errorList.push(true);
                    showMessage("Error", "Please enter unique children information", "error", 3000);
                }

            }
            else {
                errorList.push(true);
            }
        }
    }


    const Validate = (errorList) => {
        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }

        if (!state.lastName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: false
            }));
        }
        if (selectedOption == 'SSN') {
            if (!state.ssn) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorSSN: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorSSN: false
                }));
            }
        } else {
            if (!state.tin) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorTIN: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorTIN: false
                }));
            }
        }
        var toDay = toDayDate();
        if (!state.dateOfBirth || state.dateOfBirth.trim() === "") {

            setErrorMessages(prevState => ({
                ...prevState,
                errorDOB: true
            }));

            errorList.push(true);

        }
        else if (state.dateOfBirth && state.dateOfBirth > toDay) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOBFuture: true
            }));

            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOB: false
            }));
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOBFuture: false
            }));
        }


        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }
        if (state.email && !validateEmail(state.email)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: false
            }));
        }

        if (!state.phone || !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }

        if (!state.address1) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: false
            }));
        }

        //if (!state.address2) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorAddress2: true
        //    }));
        //    errorList.push(true);
        //}

        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorAddress2: false
        //    }));
        //}

        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }

        if (!state.state) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: false
            }));
        }

        if (!state.zipCode) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: false
            }));
        }

        if (!state.signature) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSignature: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSignature: false
            }));
        }

        if (!state.initials) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInitials: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInitials: false
            }));
        }

        if (!state.documentType) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDocumentType: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDocumentType: false
            }));
        }
        if (!identityImage.file && !state.identityProof) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: false
            }));
        }


        if (!state.deliveryDate) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDeliveryDate: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDeliveryDate: false
            }));
        }

        if (!state.deliveryTime) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDeliveryTime: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDeliveryTime: false
            }));
        }
        debugger;
        if ((state.AdditionalApply == HealthcareFloridaConnectApplyFor.ARelative || state.AdditionalApply == HealthcareFloridaConnectApplyFor.AChild || state.AdditionalApply == HealthcareFloridaConnectApplyFor.AStudent) && state.applyFor.includes("other")) {
            validateChild(errorList);

        }

        else {
            if (!state.deviceIdentification) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorDeviceIdentification: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorDeviceIdentification: false
                }));
            }
            if (!skipDeviceInfo) {
                if (!state.icc) {
                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorICC: true
                    }));
                    errorList.push(true);
                }
                else {
                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorICC: false
                    }));
                }
            }
            //if (!state.plan) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorPlan: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorPlan: false
            //    }));
            //}

            //if (!state.assignedPhoneNumber) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorAssignedPhoneNumber: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorAssignedPhoneNumber: false
            //    }));
            //}
        }


        if (!pictureReceivingPhone.file && !state.receivingPicturePath) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPictureReceivingPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPictureReceivingPhone: false
            }));
        }
        if (state.receiverType == 'Guardian') {
            if (!state.guardianFullName) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianFullName: true
                }));
                errorList.push(true);
            } else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianFullName: false
                }));
            }
            if (!state.guardianDOB) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianDOB: true
                }));
                errorList.push(true);
            } else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianDOB: false
                }));
            }
            if (state.guardianDOB && state.guardianDOB > toDayDate()) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianDOBFuture: true
                }));
                errorList.push(true);
            } else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianDOBFuture: false
                }));
            }
            if (!state.guardianEmail || !validateEmail(state.guardianEmail)) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianEmailAddress: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianEmailAddress: false
                }));
            }
            if (!state.guardianPhone || !validatePhoneNumber(state.guardianPhone)) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianPhone: true
                }));
                errorList.push(true);
            }

            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianPhone: false
                }));
            }

            if (!state.guardianSSN) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianSSN: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorGuardianSSN: false
                }));
            }

            if (!state.documentGuardianType) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorDocumentGuardianType: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorDocumentGuardianType: false
                }));
            }
            if (!identityGuardianImage.file && !state.identityGuardianImagePath) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorIdentityGuardianImage: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorIdentityGuardianImage: false
                }));
            }

        }

        if (state.receiverType == 'SocialWorker' && (!state.socialWorkerId || state.socialWorkerId == '')) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSelectSocialWorker: true
            }));
            errorList.push(true);
        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSelectSocialWorker: false
            }));
        }


    }
    const trimStringData = () => {
        state.firstName = state?.firstName?.trim();
        state.lastName = state?.lastName?.trim();
        state.email = state?.email?.trim();
        state.address1 = state?.address1?.trim();
        state.city = state?.city?.trim();
        state.signature = state?.signature?.trim();
        state.initials = state?.initials?.trim();
        state.collectedBy = state?.collectedBy?.trim();
    }
    const addNew = () => {
        trimStringData();
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            if (skipDeviceInfo ||
                (!state.applyFor.includes("self") && beneficiariesList.every(a => a.assignedPhoneNumber)) ||
                (!state.applyFor.includes("self") && state.assignedPhoneNumber && state.assignedPhoneNumber.length > 0)) {

                DeliveryAjaxCall();
            }
            else {
                var confirmMessage = "SIM card is not activated. Are your sure to proceed without activation?";
                if (!state.applyFor.includes("self") && beneficiariesList.length > 1) {
                    confirmMessage = "SIM card is not activated for all the devices. Are your sure to proceed without activation?";
                }
                showActionDialog(confirmMessage, "confirm", function () {
                    DeliveryAjaxCall();
                });
            }


        }

    }

    const DeliveryAjaxCall = () => {

        state.status = "Delivered"
        if (selectedOption == 'SSN') {
            state.tin = '';
        } else {
            state.ssn = '';
        }

        var method = "fdnmcchromicconnect/add";
        if (state.applicationId && state.applicationId > 0) {
            method = "fdnmcchromicconnect/update";
        }

        const formData = new FormData();

        for (var key in state) {
            if (state[key] && key != "fileToSend"
                && key != "fileName"
                && key != "identityFile"
                && key != "identityName"
                && key != "encUserID" && key != 'programBeneficiaries'
            )
                formData.append(key, state[key]);
        }
        formData.append("identityFile", identityImage.fileToSend ? identityImage.fileToSend : '');
        formData.append("identityName", identityImage.fileName ? identityImage.fileName : state.identityName);
        formData.append("receivingFile", pictureReceivingPhone.fileToSend);
        formData.append("receivingFileName", pictureReceivingPhone.fileName);
        if (state.receiverType == 'Guardian') {
            formData.append("identityGuardianImage", identityGuardianImage.fileToSend);
            formData.append("identityGuardianImageFileName", identityGuardianImage.fileName);
        }


        if (state.applyFor.includes("other")) {
            for (var i = 0; i < beneficiariesList.length; i++) {
                if (beneficiariesList[i].beneficiaryId === 0 && beneficiariesList[i].isDeleted) {
                    continue;
                }
                formData.append(`programBeneficiaries[${i}][beneficiaryId]`, beneficiariesList[i].beneficiaryId);
                formData.append(`programBeneficiaries[${i}][firstName]`, beneficiariesList[i].firstName.trim());
                formData.append(`programBeneficiaries[${i}][lastName]`, beneficiariesList[i].lastName.trim());
                formData.append(`programBeneficiaries[${i}][ssn]`, beneficiariesList[i].ssn.trim());
                formData.append(`programBeneficiaries[${i}][dateOfBirth]`, beneficiariesList[i].dateOfBirth);
                formData.append(`programBeneficiaries[${i}][hasIep]`, beneficiariesList[i].hasIep);
                formData.append(`programBeneficiaries[${i}][school]`, beneficiariesList[i].school);
                formData.append(`programBeneficiaries[${i}][accountNumber]`, beneficiariesList[i].accountNumber);
                formData.append(`programBeneficiaries[${i}][assignedPhoneNumber]`, beneficiariesList[i].assignedPhoneNumber);
                formData.append(`programBeneficiaries[${i}][icc]`, beneficiariesList[i].icc);
                formData.append(`programBeneficiaries[${i}][deviceIdentification]`, beneficiariesList[i].deviceIdentification);
                formData.append(`programBeneficiaries[${i}][activationDate]`, beneficiariesList[i]?.activationDate ? beneficiariesList[i].activationDate : '');
                formData.append(`programBeneficiaries[${i}][isDeleted]`, beneficiariesList[i].isDeleted);
                formData.append(`programBeneficiaries[${i}][isDelivered]`, beneficiariesList[i].isDelivered);

                if (beneficiariesList[i].beneficiaryId > 0) {
                    formData.append(`programBeneficiaries[${i}][createDate]`, beneficiariesList[i].createDate);
                }
            }
        }
        formData.append("IsDelivery", true);
        setIsLoading(true);
        debugger
        console.log(formData)
        PostDataAPI(method, formData, true, "formData").then((result) => {
            setIsLoading(false);
            if (result.success) {
                if (result.data) {
                    handleSuccessClose("Application saved successfully");
                }
                else {
                    showMessage("Error", "Error saving application, please contact administrator", "error", 3000);
                }
            }
            else {
                showMessage("Error", result.message, "error", 3000);

            }
        })
    }
    const sendEmailForReview = (templateType) => {
        let errorList = [];
        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }
        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }
        if (!state.phone || !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }

        if (errorList.length < 1) {
            var params = {
                firstName: state.firstName,
                lastName: state.lastName,
                emailAddress: state.email,
                phone: state.phone,
                message: '',
                reviewStatus: 'Submitted',
                templateCode: 'All',
                templateType: templateType,
                applicationId: state.applicationId,
                reviewTo: templateType
            }
            var method = "fdnmcchromicconnect/sendReviewRequestEmailForTabletProgram";
            setIsLoading(true);
            PostDataAPI(method, params, true).then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        getFFReviewLatestEmailDate(state.applicationId);
                        getFCIReviewLatestEmailDate(state.applicationId);
                        showMessage("Success", "Email sent for review successfully", "success", 3000);
                    }
                    else {
                        showMessage("Error", "Error sending email, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
            })
        } else {
        }


    }
    const [fCILatestDate, setFCILatestDate] = useState()
    const [fFLatestDate, setFFLatestDate] = useState()
    const getFFReviewLatestEmailDate = (applicationId) => {
        var params = {
            applicationId: applicationId,
            reviewTo: 'figgers_foundation'
        }
        var method = "fdnmcchromicconnect/getLatestReviewEmail";
        PostDataAPI(method, params, true).then((result) => {
            if (result.success) {
                if (result.data) {
                    setFFLatestDate(result.data.createDate);
                }
            }
        })
    }

    const getFCIReviewLatestEmailDate = (applicationId) => {
        var params = {
            applicationId: applicationId,
            reviewTo: 'figgers_communication'
        }
        var method = "fdnmcchromicconnect/getLatestReviewEmail";
        PostDataAPI(method, params, true).then((result) => {
            if (result.success) {
                if (result.data) {
                    setFCILatestDate(result.data.createDate);
                }
            }
        })
    }

    const [atLocationState, setAtLocationState] = useState([])

    const [socialWorkers, setSocialWorkers] = useState([])
    const [socialWorkersList, setSocialWorkersList] = useState([]);
    const initializations = () => {
        var params1 = {
            programeName: HealthcareTabletProgram.FloridaConnect
        };
        PostDataAPI("fdnmcchromicconnect/loadActiveSocialWorkers", params1).then((result) => {
            if (result.success && result.data) {
                const workers = [
                    { value: '', label: 'Select Social Worker ~ Agency Name' },
                    ...result.data.map((item) => ({
                        value: item.socialWorkerId,
                        label: `${toCamelCase(item.fullName)} ~ ${toCamelCase(item.agencyName)}`
                    }))
                ];

                setSocialWorkers(workers);
                setSocialWorkersList(result.data);
            }
        })

        var params2 = {
            code: "get_ff_locations",
            parameters: ['foundation_locations_palmbeach']
        };
        PostDataAPI("ddl/loadItems", params2).then((result) => {
            if (result.success && result.data != null && result.data.length > 0) {
                result.data.map((item, i) => {
                    setAtLocationState(prevState => [...prevState, { value: item.text1, label: item.text2 }]);
                })
                setState(prevState => ({
                    ...prevState,
                    atLocation: result.data[0].text1
                }));
            }
        })

        loadSysCofigurationForSIMActivation();

    }
    const loadSysCofigurationForSIMActivation = () => {
        var obj = { code: 'EnablePalmBeachSIMActivation' };
        PostDataAPI("sysconfig/getSysCofigurationByCode", obj).then((result) => {
            if (result.success && result.data != null) {
                var isEnabled = result.data.value == 'true' ? true : false;
                setIsSIMActivationEnabled(isEnabled);

            }
            else if (!result.message) {
                //showMessage("Error", result.message, "error", 3000);
            }
        });
    }

    const validateChildInformation = (index) => {
        var toDay = toDayDate();
        const validBeneficiaries = beneficiariesList.filter(beneficiary => !beneficiary.isDeleted);
        const child = validBeneficiaries[index];
        const newErrors = {};

        if (!child.deviceIdentification && child.isDelivered == true) {
            newErrors.deviceIdentification = 'Please enter IMEI #';
        }
        if (!skipDeviceInfo && child.isDelivered == true) {
            if (!child.icc) {
                newErrors.icc = 'Please enter SIM Card Number';
            }
        }
        if (!child.firstName && child.isDelivered == true) {
            newErrors.firstName = 'Please enter first name';
        }
        if (!child.lastName && child.isDelivered == true) {
            newErrors.lastName = 'Please enter last name';
        }
        if (!child.ssn && child.isDelivered == true) {
            newErrors.ssn = 'Please enter 4 digits SSN';
        }
        if (!child.dateOfBirth || child.dateOfBirth > toDay && child.isDelivered == true) {
            newErrors.dateOfBirth = 'Please enter valid date of birth';
        }
        // if (!child.school) {
        //     newErrors.childSchool = 'Please enter school name';
        // }

        if (Object.keys(newErrors).length > 0) {
            setErrorChildMessages((prevErrors) => ({
                ...prevErrors,
                [index]: newErrors,
            }));
            return true; // Validation failed
        } else {
            setErrorChildMessages((prevErrors) => {
                const newErrors = { ...prevErrors };
                if (newErrors) {
                    delete newErrors[index]
                    return newErrors;
                }

            });
        }
    };
    const handleActivateSelfClick = () => {
        if (skipDeviceInfo) return;

        let errorList = [];
        if (!state.deviceIdentification) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDeviceIdentification: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDeviceIdentification: false
            }));
        }

        if (!state.icc) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorICC: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorICC: false
            }));
        }
        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }

        if (!state.lastName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: false
            }));
        }

        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }
        if (state.email && !validateEmail(state.email)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: false
            }));
        }

        if (!state.phone || !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }

        if (!state.address1) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: false
            }));
        }


        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }

        if (!state.state) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: false
            }));
        }

        if (!state.zipCode) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: false
            }));
        }
        if (errorList.length <= 0) {
            //activate sim and get new number here
            var params = {
                applicationId: state.applicationId,
                iCC: state.icc,
                iMEI: state.deviceIdentification,
                cycleDay: new Date().getDate(),
                firstName: state.firstName,
                lastName: state.lastName,
                address1: state.address1,
                address2: state.address2,
                city: state.city,
                phone: state.phone,
                state: state.state,
                zip: state.zipCode,
                emailAddress: state.email
            }
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/activatePrepaidNumber", params, true).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    setState(prevState => ({
                        ...prevState,
                        assignedPhoneNumber: result.data.assignedPhoneNumber,
                        accountNumber: result.data.accountNumber,
                        activationDate: result.data.activationDate
                    }));
                    showMessage("Success", "SIM card activated successfully.", "success", 3000);
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
            });
        }

    }
    const handleActivateAllChildClick = (index) => {
        showMessage("Alert", "This feature is coming soon.", "warning", 3000);
    }
    const handleActivateChildClick = (index) => {
        if (skipDeviceInfo) return;

        let errorList = [];
        const validBeneficiaries = beneficiariesList.filter(beneficiary => !beneficiary.isDeleted);
        const child = validBeneficiaries[index];
        if (child) {
            var isChildNotValidated = validateChildInformation(index)
            if (isChildNotValidated) {
                errorList.push(true);
            }

        }

        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }
        if (state.email && !validateEmail(state.email)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: false
            }));
        }

        if (!state.phone || !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }

        if (!state.address1) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: false
            }));
        }


        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }

        if (!state.state) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: false
            }));
        }

        if (!state.zipCode) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: false
            }));
        }
        if (errorList.length <= 0) {
            //activate sim and get new number here
            var params = {
                applicationId: state.applicationId,
                iCC: child.icc,
                iMEI: child.deviceIdentification,
                cycleDay: new Date().getDate(),
                firstName: state.firstName,
                lastName: state.lastName,
                address1: state.address1,
                address2: state.address2,
                city: state.city,
                phone: state.phone,
                state: state.state,
                zip: state.zipCode,
                emailAddress: state.email,
                applyFor: state.applyFor,
                //beneficiaryId: child.beneficiaryId
                beneficiariesDTO: child
            }


            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/activatePrepaidNumber", params, true).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    if (child) {
                        setBeneficiariesList((prevList) => {
                            if (index < 0 || index >= prevList.length) {
                                console.error('Index out of bounds');
                                return prevList;
                            }
                            return prevList.map((child, i) => {
                                if (i === index) {
                                    return { ...child, ...result.data.beneficiariesDTO };
                                }
                                return child;
                            });
                        });
                    }
                    showMessage("Success", "SIM card activated successfully.", "success", 3000);
                } else {
                    showMessage("Error", "Some error occurred in SIM card activation.", "error", 3000);
                }
            });
        }

    }

    const [recipientState, setRecipientState] = useState(record ? record.additionalApply : "");


    const handleSelfChange = (event) => {
        const { value, checked } = event.target;

        setState(prev => {
            let updated = [...prev.applyFor];

            if (checked) {
                updated.push(value);
            } else {
                updated = updated.filter(item => item !== value);
            }

            return {
                ...prev,
                applyFor: updated
            };
        });
    }

    const handleAdditional = (event) => {
        const value = event.target.value;

        setRecipientState(value);

        setState(prevState => ({
            ...prevState,
            AdditionalApply: value
        }));
    };


    useEffect(() => {
        initializations();
        debugger

        if (record && record.applicationId > 0) {
            const applyForArray = record.applyFor.split();
            setState(prevState => ({
                ...prevState,
                'applyFor': applyForArray
            }))
            debugger
            console.log(applyForArray);
            var option = (record && record.ssn) ? 'SSN' : 'TribalIdentification'
            setSelectedOption(option);
            const currentDate = new Date();
            record.deliveryDate = formatDate(currentDate);
            record.deliveryTime = formatTime(currentDate);
            record.receiverType = record.receiverType ? record.receiverType : 'Self';
            record.collectedBy = record.firstName + ' ' + record.lastName;
            setState(record)

            const updatedBeneficiaries = record.programBeneficiaries
                ? record.programBeneficiaries.map(beneficiary => {
                    if (beneficiary.dateOfBirth && beneficiary.dateOfBirth.includes('T')) {
                        beneficiary.dateOfBirth = beneficiary.dateOfBirth.split('T')[0];
                        beneficiary.isDelivered = true;
                    }
                    return beneficiary;
                })
                : [];
            console.log("updatedBeneficiaries", updatedBeneficiaries);
            setBeneficiariesList(updatedBeneficiaries);
            getFFReviewLatestEmailDate(record.applicationId);
            getFCIReviewLatestEmailDate(record.applicationId);
            setIsReviewLinksVisible(true);
        }
        if (skipDeviceInfo) {
            setErrorMessages(prev => ({
                ...prev,
                errorICC: false,
                errorAssignedPhoneNumber: false
            }));

            setErrorChildMessages(prev => {
                const updated = { ...prev };

                Object.keys(updated).forEach(index => {
                    if (updated[index]) {
                        delete updated[index].icc;
                        delete updated[index].assignedPhoneNumber;

                        if (Object.keys(updated[index]).length === 0) {
                            delete updated[index];
                        }
                    }
                });

                return updated;
            });
        }

    }, [skipDeviceInfo]);

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                PaperComponent={DraggableComponent}
                maxWidth="lg"
                {...props} >
                <div className={classes.dialogContent}>



                    {cropImagedialog ?
                        <CropDemo open={openCropImage} onClose={closeCropImage} fieldName={fieldName} src={fileUrl} onSave={onSave}></CropDemo> : ''
                    }

                    {/* <ImageCropModal open={true} onClose={false} src={'https://dluxbuilder.us/wp-content/uploads/photo-gallery/photo_2022-02-03_18-14-10_(1).jpg'}></ImageCropModal> */}

                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Application Form {record && record.applicationId > 0 ? ' - ' + state.firstName + (state.middleName ? ' ' + state.middleName : '') + ' ' + state.lastName + ' | PB-' + (state.ssn ? state.ssn : state.tin) + (state.version && state.version > 0 ? "-" + state.version : "") : ''}</Typography>

                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>


                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <Scrollbars autoHeight autoHeightMax={480}>
                            <div className={classes.content}>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.leftArea}>
                                        <Grid container className={classes.BeneMain}>
                                            <Grid item sm={12} md={12}>
                                                <h2 className={classes.applyingFor}>Applying For</h2>
                                            </Grid>

                                            <Grid item sm={12} md={12} lg={12} xl={12}>
                                                <FormControl component="fieldset" style={{ flexDirection: 'row' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                value="self"
                                                                checked={state.applyFor.includes("self")}
                                                                onChange={handleSelfChange}
                                                            />
                                                        }
                                                        label="Self"
                                                    />

                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                value="other"
                                                                checked={state.applyFor.includes("other")}
                                                                onChange={handleSelfChange}
                                                            />
                                                        }
                                                        label="Other"
                                                    />
                                                </FormControl>

                                            </Grid>
                                            {state.applyFor.includes("other") ?
                                                <Grid item sm={12} md={12} lg={12} xl={12} className={classes.radioInfo}>
                                                    <FormControl component="fieldset">
                                                        <RadioGroup name="gender" value={recipientState} onChange={handleAdditional}>

                                                            <FormControlLabel value={"A Child"} control={<Radio />} label="A Child" />
                                                            <FormControlLabel value={"A Student"} control={<Radio />} label="A Student" />
                                                            <FormControlLabel value={"A Relative"} control={<Radio />} label="A Relative" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                    {errorMessages.errorAddChildInfor && (state.applyFor.includes("other") && (!beneficiariesList || beneficiariesList.length <= 0)) ? (<FormHelperText style={{ color: "red" }} >
                                                        Please add person information
                                                    </FormHelperText>) : ('')}
                                                </Grid> : ''
                                            }



                                        </Grid>
                                        <Grid container className={classes.collapse}>
                                            {(recipientState == "A Child" || recipientState == "A Student" || recipientState == "A Relative") && state.applyFor.includes("other") ?

                                                <Grid container className={classes.collapse}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                        >
                                                            <h3 className={classes.sectionHeadingAccord}>Recipient Information</h3>
                                                        </AccordionSummary>
                                                        <AccordionDetails>

                                                            <>
                                                                <Grid item sm={12} md={12} lg={12} xl={12}>
                                                                    <span className={classes.addNotification} onClick={handleAddBeneficiaryItem}>Add {
                                                                        recipientState == "A Child" ? "Child" : recipientState == "A Student" ? "Student" : recipientState == "A Relative" ? "Relative" : ""} <AddCircleOutlineIcon /> </span>
                                                                </Grid>




                                                                {(recipientState == "A Child" || recipientState == "A Student" || recipientState == "A Relative") && state.applyFor.includes("other") ?
                                                                    <>
                                                                        <Grid container>
                                                                            {beneficiariesList?.filter(t => !t.isDeleted).map((item, index) => (
                                                                                <Grid row container alignItems={'center'}>
                                                                                    <Grid xl={12} md={12} sm={12} lg={12}>
                                                                                        <Grid container className={classes.ChildMain}>
                                                                                            <Grid container>
                                                                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                                                                    {beneficiariesList.length == 1 ? '' :
                                                                                                        <h3 className={classes.childHeading}>
                                                                                                            {record ?
                                                                                                                record.applyFor == 'A Child' ? "Child " :
                                                                                                                    record.applyFor == 'A Student' ? "Student " :
                                                                                                                        record.applyFor == 'A Relative' ? " Relative " : ''
                                                                                                                :
                                                                                                                recipientState == 'A Child' ? "Child " :
                                                                                                                    recipientState == 'A Student' ? "Student " :
                                                                                                                        recipientState == 'A Relative' ? " Relative " : ''}
                                                                                                            {index + 1}</h3>
                                                                                                    }

                                                                                                </Grid>
                                                                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className={classes.childClose}>
                                                                                                    <span onClick={() => { handleDeleteBeneficiaryItem(item, index) }}>
                                                                                                        <img src={DeleteIcon} /></span>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                            <Grid container>
                                                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                                    <Grid row >
                                                                                                        <Label title="First Name" size={12} mandatory={true} />
                                                                                                        <InputBaseField
                                                                                                            name="firstName"
                                                                                                            value={item.firstName}
                                                                                                            onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                            placeholder="First Name"
                                                                                                            type="text"
                                                                                                            MaxLength={50}
                                                                                                            useCamelCase={true}
                                                                                                        />
                                                                                                        {errorChildMessages[index]?.firstName && !item.firstName && (
                                                                                                            <span style={{ color: 'red' }}>{errorChildMessages[index].firstName}</span>
                                                                                                        )}
                                                                                                        {/*{errorMessages.errorBeneFirstName && !item.firstName ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                                        {/*    Please enter first name*/}
                                                                                                        {/*</FormHelperText>) : ('')}*/}
                                                                                                    </Grid>

                                                                                                </Grid>


                                                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                                    <Grid row >
                                                                                                        <Label title="Last Name" size={12} mandatory={true} />
                                                                                                        <InputBaseField
                                                                                                            name="lastName"
                                                                                                            value={item.lastName}
                                                                                                            onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                            placeholder="Last Name"
                                                                                                            type="text"
                                                                                                            MaxLength={50}
                                                                                                            useCamelCase={true}
                                                                                                        />
                                                                                                        {errorChildMessages[index]?.lastName && !item.lastName && (
                                                                                                            <span style={{ color: 'red' }}>{errorChildMessages[index].lastName}</span>
                                                                                                        )}
                                                                                                        {/*{errorMessages.errorBeneLastName && !item.lastName ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                                        {/*    Please enter last name*/}
                                                                                                        {/*</FormHelperText>) : ('')}*/}
                                                                                                    </Grid>

                                                                                                </Grid>

                                                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                                    <Grid row >
                                                                                                        <Label title="Last 4 digit SSN" size={12} mandatory={true} />
                                                                                                        <InputBaseField
                                                                                                            name="ssn"
                                                                                                            value={item.ssn}
                                                                                                            onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                            placeholder="Last 4 digit SSN"
                                                                                                            type="text"
                                                                                                            MaxLength={4}
                                                                                                            onKeyPress={handleNumberKeyPress}
                                                                                                        />

                                                                                                        {errorChildMessages[index]?.ssn && !item.ssn && (
                                                                                                            <span style={{ color: 'red' }}>{errorChildMessages[index].ssn}</span>
                                                                                                        )}
                                                                                                        {/*{errorMessages.errorBeneSSN && !item.ssn ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                                        {/*    Please enter last 4 digit SSN*/}
                                                                                                        {/*</FormHelperText>) : ('')}*/}
                                                                                                    </Grid>

                                                                                                </Grid>


                                                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                                    <Grid row >
                                                                                                        <Label title="Date of Birth" size={12} mandatory={true} />
                                                                                                        <Input
                                                                                                            name="dateOfBirth"
                                                                                                            placeholder="MM/DD/YYYY"
                                                                                                            value={item.dateOfBirth}
                                                                                                            maxLength={10}
                                                                                                            onChange={(e) => {
                                                                                                                let value = e.target.value.replace(/\D/g, "");

                                                                                                                // Auto format MM/DD/YYYY
                                                                                                                if (value.length >= 3 && value.length <= 4) {
                                                                                                                    value = value.slice(0, 2) + "/" + value.slice(2);
                                                                                                                } else if (value.length >= 5) {
                                                                                                                    value =
                                                                                                                        value.slice(0, 2) +
                                                                                                                        "/" +
                                                                                                                        value.slice(2, 4) +
                                                                                                                        "/" +
                                                                                                                        value.slice(4, 8);
                                                                                                                }

                                                                                                                handleBeneInputChange(
                                                                                                                    {
                                                                                                                        target: {
                                                                                                                            name: "dateOfBirth",
                                                                                                                            value,
                                                                                                                        },
                                                                                                                    },
                                                                                                                    index
                                                                                                                );
                                                                                                            }}
                                                                                                            onKeyDown={(e) => {
                                                                                                                // Prevent calendar popup keys if browser tries
                                                                                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                                                                                    e.preventDefault();
                                                                                                                }
                                                                                                            }}
                                                                                                            className="custom-input"
                                                                                                        />
                                                                                                        {errorChildMessages[index]?.dateOfBirth && (!item.dateOfBirth || (item.dateOfBirth && item.dateOfBirth > toDayDate())) && (
                                                                                                            <span style={{ color: 'red' }}>{errorChildMessages[index].dateOfBirth}</span>
                                                                                                        )}
                                                                                                        {/*{errorMessages.errorBeneDOB && (!item.dateOfBirth || (item.dateOfBirth && item.dateOfBirth > toDayDate())) ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                                        {/*    Please enter valid date of birth*/}
                                                                                                        {/*</FormHelperText>) : ('')}*/}
                                                                                                    </Grid>

                                                                                                </Grid>
                                                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                                    <Grid row >
                                                                                                        <Label title="School Name" size={12} />
                                                                                                        <InputBaseField
                                                                                                            name="school"
                                                                                                            value={item.school == 'undefined' ? '' : item.school}
                                                                                                            onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                            placeholder="School Name"
                                                                                                            type="text"
                                                                                                            MaxLength={50}
                                                                                                            useCamelCase={true}
                                                                                                        />

                                                                                                    </Grid>

                                                                                                </Grid>

                                                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.checkboxMain}>
                                                                                                    <FormControlLabel
                                                                                                        className={classes.checkBox}
                                                                                                        control={<Checkbox onChange={(event) => { handleBeneInputChange(event, index) }} name="hasIep" checked={item.hasIep} />}
                                                                                                        label="Does this child have an individual learning plan (IEP) ?"
                                                                                                    />
                                                                                                </Grid>
                                                                                                {matchingChildrenWithParent.includes(index) && (
                                                                                                    <p style={{ color: "red" }}>
                                                                                                        This child's information matches the parent's information.
                                                                                                    </p>
                                                                                                )}
                                                                                            </Grid>
                                                                                        </Grid>

                                                                                    </Grid>




                                                                                </Grid>
                                                                            ))
                                                                            }
                                                                        </Grid></>
                                                                    : ''}
                                                            </>

                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Grid>
                                                : ''
                                            }


                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <h3 className={classes.sectionHeadingAccord}>Personal Information</h3>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div>
                                                        <Grid container spacing={3}>

                                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                                <Grid row >
                                                                    <Label title="First Name" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="firstName"
                                                                        value={state.firstName}
                                                                        onChange={handleChange}
                                                                        placeholder="First Name"
                                                                        type="text"
                                                                        MaxLength={15}
                                                                        useCamelCase={true}
                                                                    />
                                                                    {errorMessages.errorFirstName && !state.firstName ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter first name
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                                <Grid row >
                                                                    <Label title="Middle Name" size={12} />
                                                                    <InputBaseField
                                                                        name="middleName"
                                                                        value={state.middleName}
                                                                        onChange={handleChange}
                                                                        placeholder="Middle Name"
                                                                        type="text"
                                                                        MaxLength={15}
                                                                        useCamelCase={true}
                                                                    />
                                                                    {errorMessages.errorMiddleName && !state.middleName ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter middle name
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>


                                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                                <Grid row >
                                                                    <Label title="Last Name" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="lastName"
                                                                        value={state.lastName}
                                                                        onChange={handleChange}
                                                                        placeholder="Last Name"
                                                                        type="text"
                                                                        MaxLength={15}
                                                                        useCamelCase={true}
                                                                    />
                                                                    {errorMessages.errorLastName && !state.lastName ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter last name
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>

                                                        </Grid>

                                                        <Grid container>
                                                            <Grid item sm={12} md={12} lg={12} xl={12} className={classes.radioInfo}>
                                                                <FormControl component="fieldset">
                                                                    <RadioGroup name="gender" value={selectedOption} onChange={handleOptionChange}>
                                                                        <FormControlLabel value="SSN" control={<Radio />} label="SSN" />
                                                                        <FormControlLabel value="TribalIdentification" control={<Radio />} label="Tribal Identification Number" />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </Grid>

                                                        </Grid>

                                                        <Grid container spacing={3}>

                                                            {selectedOption == 'SSN' ?
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Last 4 digit SSN" size={12} mandatory={true} />
                                                                        <InputBaseField
                                                                            name="ssn"
                                                                            value={state.ssn}
                                                                            onChange={handleChange}
                                                                            placeholder="Last 4 digit SSN"
                                                                            type="text"
                                                                            MaxLength={4}
                                                                            onKeyPress={handleNumberKeyPress}
                                                                        />
                                                                        {errorMessages.errorSSN && !state.ssn ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please enter last 4 digit SSN
                                                                        </FormHelperText>) : ('')}

                                                                    </Grid>
                                                                </Grid> :

                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Tribal Identification Number" size={12} mandatory={true} />
                                                                        <InputBaseField
                                                                            name="tin"
                                                                            value={state.tin}
                                                                            onChange={handleChange}
                                                                            placeholder="TIN"
                                                                            type="text"
                                                                            MaxLength={14}
                                                                            onKeyPress={handleNumberKeyPress}
                                                                        />
                                                                        {errorMessages.errorTIN && !state.tin ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please enter tribal identification number
                                                                        </FormHelperText>) : ('')}

                                                                    </Grid>
                                                                </Grid>

                                                            }

                                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                                                                <Grid row >
                                                                    <Label title="Date of Birth" size={12} mandatory={true} />
                                                                    <Input
                                                                        name="dateOfBirth"
                                                                        placeholder="MM/DD/YYYY"
                                                                        value={state.dateOfBirth}
                                                                        maxLength={10}
                                                                        onChange={(e) => {
                                                                            let value = e.target.value.replace(/\D/g, "");

                                                                            // Auto format MM/DD/YYYY
                                                                            if (value.length > 2 && value.length <= 4) {
                                                                                value = value.slice(0, 2) + "/" + value.slice(2);
                                                                            } else if (value.length > 4) {
                                                                                value =
                                                                                    value.slice(0, 2) +
                                                                                    "/" +
                                                                                    value.slice(2, 4) +
                                                                                    "/" +
                                                                                    value.slice(4, 8);
                                                                            }

                                                                            handleChange({
                                                                                target: {
                                                                                    name: "dateOfBirth",
                                                                                    value,
                                                                                },
                                                                            });
                                                                        }}
                                                                        className="custom-input"
                                                                    />
                                                                    {errorMessages.errorDOB && !state.dateOfBirth ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter date of birth
                                                                    </FormHelperText>) : ('')}
                                                                    {errorMessages.errorDOBFuture && state.dateOfBirth > toDayDate() ? (<FormHelperText style={{ color: "red" }} >
                                                                        Date of birth cannot be in future
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>
                                                        </Grid>



                                                    </div>

                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>

                                        <Grid container className={classes.collapse}>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <h3 className={classes.sectionHeadingAccord}>Contact Information</h3>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div>
                                                        <Grid container spacing={2} >
                                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                <Grid row >
                                                                    <Label title="Email Address" size={12} mandatory={true} />

                                                                    <InputBaseField
                                                                        name="email"
                                                                        value={state.email}
                                                                        onChange={handleChange}
                                                                        placeholder="Email Address"
                                                                        type="text"
                                                                        MaxLength={50}
                                                                    />
                                                                    {errorMessages.errorEmailAddress && (!state.email || !validateEmail(state.email)) ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter valid email
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>
                                                            </Grid>


                                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                <Grid row >
                                                                    <Label title="Phone #" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="phone"
                                                                        value={state.phone}
                                                                        onChange={handlePhoneChange}
                                                                        placeholder="Phone #"
                                                                        type="text"
                                                                        MaxLength={14}
                                                                    />
                                                                    {errorMessages.errorPhone && (!state.phone || !validatePhoneNumber(state.phone)) ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter valid phone number
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>

                                                        </Grid>



                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                <Grid row >
                                                                    <Label title="Address" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="address1"
                                                                        value={state.address1}
                                                                        onChange={handleChange}
                                                                        placeholder="Address"
                                                                        type="text"
                                                                        MaxLength={50}
                                                                        useCamelCase={true}
                                                                    />
                                                                    {errorMessages.errorAddress1 && !state.address1 ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter address
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>
                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                <Grid row >
                                                                    <Label title="Apartment, Unit, etc." size={12} />
                                                                    <InputBaseField
                                                                        name="address2"
                                                                        value={state.address2}
                                                                        onChange={handleChange}
                                                                        placeholder="Apartment, Unit, etc."
                                                                        type="text"
                                                                        MaxLength={50}
                                                                    />
                                                                    {errorMessages.errorAddress2 && !state.address2 ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter apartment, unit
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>
                                                        </Grid>

                                                        <Grid container spacing={2}>
                                                        </Grid>

                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                                <Grid row >
                                                                    <Label title="Zip Code" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="zipCode"
                                                                        value={state.zipCode}
                                                                        onChange={handleZipCodeChange}
                                                                        placeholder="Zip Code"
                                                                        type="text"
                                                                        MaxLength={9}
                                                                        onKeyPress={handleNumberKeyPress}
                                                                    />
                                                                    {errorMessages.errorZip && !state.zipCode ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter zip code
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>
                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                                <Grid row >
                                                                    <Label title="City" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="city"
                                                                        value={state.city}
                                                                        onChange={handleChange}
                                                                        placeholder="City"
                                                                        type="text"
                                                                        MaxLength={14}
                                                                        useCamelCase={true}
                                                                    />
                                                                    {errorMessages.errorCity && !state.city ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please enter city
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>

                                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                                <Grid row >
                                                                    <Label title="State" size={12} mandatory={true} />
                                                                    <Select
                                                                        size="small"
                                                                        native
                                                                        name="state"
                                                                        value={state?.state}
                                                                        onChange={handleSelectChange}
                                                                        placeholder="Select"
                                                                        label="Select"
                                                                        className={classes.selectBaseInput}
                                                                    >
                                                                        {lstStates.map(option =>
                                                                            <option value={option.value}>{option.label}</option>
                                                                        )
                                                                        }
                                                                    </Select>
                                                                    {errorMessages.errorState && !state.state ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please select state
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>


                                        <Grid container className={classes.collapse}>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <h3 className={classes.sectionHeadingAccord}>Consent and Agreement</h3>
                                                </AccordionSummary>
                                                <AccordionDetails>

                                                    <Grid container spacing={2}>

                                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                            <Grid row>
                                                                <Label title="Signature" size={12} mandatory={true} />
                                                                <InputBaseField
                                                                    name="signature"
                                                                    value={state.signature}
                                                                    onChange={handleChange}
                                                                    placeholder="Signature"
                                                                    type="text"
                                                                    MaxLength={10}
                                                                />
                                                                {errorMessages.errorSignature && !state.signature ? (<FormHelperText style={{ color: "red" }} >
                                                                    Please enter signature
                                                                </FormHelperText>) : ('')}
                                                            </Grid>

                                                        </Grid>


                                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                            <Grid row>
                                                                <Label title="Your Initials" size={12} mandatory={true} />
                                                                <InputBaseField
                                                                    name="initials"
                                                                    value={state.initials}
                                                                    onChange={handleChange}
                                                                    placeholder="Your Initials"
                                                                    type="text"
                                                                    MaxLength={7}
                                                                />
                                                                {errorMessages.errorInitials && !state.initials ? (<FormHelperText style={{ color: "red" }} >
                                                                    Please enter initials
                                                                </FormHelperText>) : ('')}
                                                            </Grid>

                                                        </Grid>


                                                    </Grid>


                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>

                                        <Grid container className={classes.collapse}>
                                            <Accordion defaultExpanded>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <h3 className={classes.sectionHeadingAccord}>Proof of Identity</h3>
                                                </AccordionSummary>




                                                <AccordionDetails>



                                                    {isData ?
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                {identityImage.file || state.identityProof ?
                                                                    <>
                                                                        <img src={identityImage.file ? identityImage.file : '.' + state.identityProof} width="100%" />
                                                                    </>
                                                                    : <img src={PreviewPhoto} width="100%" />
                                                                }
                                                            </Grid>
                                                        </Grid> :
                                                        <>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Document Type" size={12} mandatory={true} />

                                                                        <Select
                                                                            size="small"
                                                                            native
                                                                            name="documentType"
                                                                            value={state?.documentType}
                                                                            onChange={handleSelectChange}
                                                                            placeholder="Select"
                                                                            label="Select"
                                                                            className={classes.selectBaseInput}
                                                                        >
                                                                            {documentType.map(option =>
                                                                                <option value={option.value}>{option.label}</option>
                                                                            )
                                                                            }
                                                                        </Select>
                                                                        {errorMessages.errorDocumentType && !state.documentType ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please select document type
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>


                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Upload Document" size={12} mandatory={true} />
                                                                        <input type="file" id="fileUploadField" name="proofOfIdentity" ref={inputFile} className={classes.inputFile} onChange={handleFileChange} accept=".png, .jpg, .jpeg" />

                                                                        <label htmlFor="fileUploadField" className={classes.customFileButton}>
                                                                            <span className={classes.spanBtn}>Choose file</span> {identityImage.file ? identityImage.fileName : state.identityName ? state.identityName : 'Choose a file'}
                                                                        </label>

                                                                        <div className={classes.fileExtenNotif}><i>.png, .jpg, .jpeg files only</i></div>
                                                                        {errorMessages.errorIdentityImage && !identityImage.file ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please select document
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>

                                                                </Grid>

                                                            </Grid>
                                                            <Grid container className={identityImage.file || state.identityProof ? classes.imageBox : ''}>
                                                                {identityImage.file || state.identityProof ?
                                                                    <>
                                                                        <img src={identityImage.file ? identityImage.file : '.' + state.identityProof} className={classes.previewImg} style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', width: '325px', height: '204.1px', margin: '5px' }} />
                                                                    </>
                                                                    : ''
                                                                }
                                                            </Grid>
                                                        </>
                                                    }


                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>


                                        {isReviewLinksVisible ? <Grid container className={classes.collapse}>
                                            <Accordion defaultExpanded>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <h3 className={classes.sectionHeadingAccord}>Ask for Review</h3>
                                                </AccordionSummary>

                                                <AccordionDetails>
                                                    <div style={{ display: 'flex', flexFlow: 'row', gap: '8px' }}>
                                                        <div>
                                                            <div className={classes.reviewBtn} onClick={() => { sendEmailForReview('figgers_foundation') }}>
                                                                <img src={AskForReviewStar} />
                                                                <h4> Figgers Foundation Reviews</h4>

                                                            </div>
                                                            <h4 className={classes.reviewDate}> {fFLatestDate ? 'Review Date: ' + formatDateTime(fFLatestDate) : ''}</h4>
                                                        </div>

                                                        <div>

                                                            <div className={classes.reviewBtn} onClick={() => { sendEmailForReview('figgers_communication') }}>
                                                                <img src={AskForReviewStar} />
                                                                <h4> Figgers Communication Reviews</h4>

                                                            </div>
                                                            <h4 className={classes.reviewDate}>{fCILatestDate ? 'Review Date: ' + formatDateTime(fCILatestDate) : ''}</h4>
                                                        </div>



                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid> : ''}


                                    </Grid>


                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.rightArea}>

                                        <h3 className={classes.sectionHeading} style={{ marginBottom: 0 }}>Delivery Details <span style={{ float: 'right', fontWeight: '400', fontSize: '15px' }}>{state.deliveryDate} {state.deliveryTime}</span></h3>

                                        {/*<Grid container spacing={2}>*/}

                                        {/*    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>*/}
                                        {/*        <Grid row >*/}
                                        {/*            <Label title="Date" size={12} mandatory={true} />*/}
                                        {/*            <InputBaseField*/}
                                        {/*                name="deliveryDate"*/}
                                        {/*                value={state.deliveryDate}*/}
                                        {/*                onChange={handleChange}*/}
                                        {/*                placeholder="Date"*/}
                                        {/*                type="text"*/}
                                        {/*                IsDisabled={true}*/}
                                        {/*            />*/}
                                        {/*            {errorMessages.errorDeliveryDate && !state.deliveryDate ? (<FormHelperText style={{ color: "red" }} >*/}
                                        {/*                Please enter valid date*/}
                                        {/*            </FormHelperText>) : ('')}*/}
                                        {/*        </Grid>*/}

                                        {/*    </Grid>*/}

                                        {/*    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>*/}
                                        {/*        <Grid row >*/}
                                        {/*            <Label title="Time" size={12} mandatory={true} />*/}
                                        {/*            <InputBaseField*/}
                                        {/*                name="deliveryTime"*/}
                                        {/*                value={state.deliveryTime}*/}
                                        {/*                onChange={handleChange}*/}
                                        {/*                placeholder="Time"*/}
                                        {/*                type="text"*/}
                                        {/*                IsDisabled={true}*/}
                                        {/*            />*/}
                                        {/*            {errorMessages.errorDeliveryTime && !state.deliveryTime ? (<FormHelperText style={{ color: "red" }} >*/}
                                        {/*                Please enter valid time*/}
                                        {/*            </FormHelperText>) : ('')}*/}
                                        {/*        </Grid>*/}

                                        {/*    </Grid>*/}

                                        {/*</Grid>*/}
                                        <Grid container className={classes.collapse}>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <h3 className={classes.sectionHeadingAccord}>Device Information</h3>
                                                </AccordionSummary>

                                                <AccordionDetails style={{ paddingTop: 0 }}>
                                                    <Grid row>
                                                        <div className={classes.skipDevInfo}>
                                                            <span>Skip Service Info</span>
                                                            <Checkbox
                                                                type="checkbox"
                                                                id={`skip-device-info`}
                                                                checked={skipDeviceInfo}
                                                                onChange={(e) => setSkipDeviceInfo(e.target.checked)}
                                                                name="skipDeviceInfo"
                                                                className="groupcheckbox"
                                                            />
                                                        </div>
                                                        <Button className={classes.activeMdnAll} onClick={() => { handleActivateAllChildClick() }}>Activate All</Button>
                                                    </Grid>
                                                    {(recipientState == "A Child" || recipientState == "A Student" || recipientState == "A Relative") && state.applyFor.includes("other") ?

                                                        beneficiariesList?.filter(t => !t.isDeleted).map((child, index) => (
                                                            <label
                                                                key={index}
                                                                htmlFor={`beneficiary-delivered-${index}`}
                                                                className={classes.beneficiarySelect}
                                                            >
                                                                <div className={'groupCheckContain'}>
                                                                    <span>Add Delivery: </span>
                                                                    <Checkbox
                                                                        type="checkbox"
                                                                        id={`beneficiary-delivered-${index}`}
                                                                        name={`beneficiaryDelivered`}
                                                                        checked={beneficiariesList.length == 1 ? true : child.isDelivered}
                                                                        onChange={(event) => handleSelectDelivered(event, index)}
                                                                        disabled={beneficiariesList.length == 1 ? true : state.applicationId > 0 ? false : true}
                                                                        className="groupcheckbox"
                                                                    />
                                                                </div>

                                                                {/* Box Content */}
                                                                <div className={classes.deviceInfo}>
                                                                    <Grid container spacing={2}>
                                                                        <h3 style={{ fontWeight: 600, fontSize: '16px', margin: '6px 6px' }}>
                                                                            {child.firstName} {child.lastName}
                                                                        </h3>
                                                                    </Grid>

                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                            <Grid row>
                                                                                <Label title="IMEI #" size={12} mandatory={true} />
                                                                                <InputBaseField
                                                                                    name="deviceIdentification"
                                                                                    value={child.deviceIdentification == 'null' || child.deviceIdentification == null || child.deviceIdentification == 'undefined' ? null : child.deviceIdentification}
                                                                                    onChange={(event) => handleBeneInputChange(event, index)}
                                                                                    placeholder="IMEI #"
                                                                                    type="text"
                                                                                    MaxLength={20}
                                                                                    onKeyPress={handleNumberKeyPress}
                                                                                    onPaste={(e) => e.preventDefault()}
                                                                                    onDrop={(e) => e.preventDefault()}
                                                                                    IsDisabled={child?.assignedPhoneNumber && child?.assignedPhoneNumber.length > 0}
                                                                                />
                                                                                {errorChildMessages[index]?.deviceIdentification && !child.deviceIdentification && (
                                                                                    <span style={{ color: 'red' }}>{errorChildMessages[index].deviceIdentification}</span>
                                                                                )}
                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                            <Grid row>
                                                                                <Label title="SIM Card Number" size={12} mandatory={true} />
                                                                                <InputBaseField
                                                                                    name="icc"
                                                                                    value={child.icc == 'null' || child.icc == null || child.icc == 'undefined' ? null : child.icc}
                                                                                    onChange={(event) => handleBeneInputChange(event, index)}
                                                                                    placeholder="ICC #"
                                                                                    type="text"
                                                                                    MaxLength={20}
                                                                                    onKeyPress={handleNumberKeyPress}
                                                                                    onPaste={(e) => e.preventDefault()}
                                                                                    onDrop={(e) => e.preventDefault()}
                                                                                    IsDisabled={skipDeviceInfo ? true : (child?.assignedPhoneNumber && child?.assignedPhoneNumber.length > 0)}
                                                                                />
                                                                                {!skipDeviceInfo && errorChildMessages[index]?.icc && !child.icc && (
                                                                                    <span style={{ color: 'red' }}>{errorChildMessages[index].icc}</span>
                                                                                )}
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid container spacing={2} style={{ alignItems: 'end' }}>
                                                                        <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                                                                            <Grid row>
                                                                                <Label title="Assigned Phone Number" size={12} mandatory={true} />
                                                                                <InputBaseField
                                                                                    name="assignedPhoneNumber"
                                                                                    value={child.assignedPhoneNumber}
                                                                                    onChange={(event) => handleBeneInputChange(event, index)}
                                                                                    placeholder="Phone Number"
                                                                                    type="text"
                                                                                    MaxLength={14}
                                                                                    IsDisabled={true}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                                            <Grid row>
                                                                                {!skipDeviceInfo && (
                                                                                    <Button
                                                                                        className={
                                                                                            isSIMActivationEnabled &&
                                                                                                ((state.applicationId && state.applicationId > 0) &&
                                                                                                    (!child?.assignedPhoneNumber || child?.assignedPhoneNumber.length <= 0))
                                                                                                ? classes.getMdn
                                                                                                : classes.activeMdn
                                                                                        }
                                                                                        onClick={() => handleActivateChildClick(index)}
                                                                                        disabled={
                                                                                            !isSIMActivationEnabled ||
                                                                                            (!state.applicationId || state.applicationId === 0) ||
                                                                                            (child?.assignedPhoneNumber && child?.assignedPhoneNumber.length > 0)
                                                                                        }
                                                                                    >
                                                                                        Activate
                                                                                    </Button>
                                                                                )}
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            </label>
                                                        ))
                                                        :

                                                        <>
                                                            <div className={classes.deviceInfo}>
                                                                <Grid container spacing={2}>

                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                        <Grid row >
                                                                            <Label title="IMEI #" size={12} mandatory={true} />
                                                                            <InputBaseField
                                                                                name="deviceIdentification"
                                                                                value={state.deviceIdentification}
                                                                                onChange={handleChange}
                                                                                placeholder="IMEI #"
                                                                                type="text"
                                                                                MaxLength={20}
                                                                                onKeyPress={handleNumberKeyPress}
                                                                                onPaste={(e) => e.preventDefault()}
                                                                                onDrop={(e) => e.preventDefault()}
                                                                                IsDisabled={state?.assignedPhoneNumber && state?.assignedPhoneNumber.length > 0}
                                                                            />
                                                                            {errorMessages.errorDeviceIdentification && !state.deviceIdentification ? (<FormHelperText style={{ color: "red" }} >
                                                                                Please enter IMEI #
                                                                            </FormHelperText>) : ('')}
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                        <Grid row >
                                                                            <Label title="SIM Card Number" size={12} mandatory={true} />
                                                                            <InputBaseField
                                                                                name="icc"
                                                                                value={state.icc}
                                                                                onChange={handleChange}
                                                                                placeholder="ICC #"
                                                                                type="text"
                                                                                MaxLength={20}
                                                                                onKeyPress={handleNumberKeyPress}
                                                                                onPaste={(e) => e.preventDefault()}
                                                                                onDrop={(e) => e.preventDefault()}
                                                                                IsDisabled={skipDeviceInfo ? true : (state?.assignedPhoneNumber && state?.assignedPhoneNumber.length > 0)}
                                                                            />
                                                                            {!skipDeviceInfo && errorMessages.errorICC && !state.icc ? (<FormHelperText style={{ color: "red" }} >
                                                                                Please enter SIM Card Number
                                                                            </FormHelperText>) : ('')}
                                                                        </Grid>
                                                                    </Grid>

                                                                </Grid>


                                                                <Grid container spacing={2} style={{ alignItems: 'end' }}>
                                                                    <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                                                                        <Grid row >
                                                                            <Label title="Assigned Phone Number" size={12} mandatory={true} />
                                                                            <InputBaseField
                                                                                name="assignedPhoneNumber"
                                                                                value={state.assignedPhoneNumber}
                                                                                onChange={handlePhoneChange}
                                                                                placeholder="Phone Number"
                                                                                type="text"
                                                                                MaxLength={14}
                                                                                IsDisabled={true}
                                                                            />
                                                                            {!skipDeviceInfo && errorMessages.errorAssignedPhoneNumber && (!state.assignedPhoneNumber || !validatePhoneNumber(state.assignedPhoneNumber)) ? (<FormHelperText style={{ color: "red" }} >
                                                                                Please enter phone number
                                                                            </FormHelperText>) : ('')}
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                                        <Grid row>
                                                                            <br></br>
                                                                            {!skipDeviceInfo && (
                                                                                <Button className={isSIMActivationEnabled &&
                                                                                    ((state.applicationId && state.applicationId > 0) &&
                                                                                        (!state?.assignedPhoneNumber || state?.assignedPhoneNumber.length <= 0)
                                                                                    ) ? classes.getMdn : classes.activeMdn}
                                                                                    onClick={() => { handleActivateSelfClick() }}
                                                                                    disabled={!isSIMActivationEnabled ||
                                                                                        (!state.applicationId || state.applicationId == 0) ||
                                                                                        (state?.assignedPhoneNumber && state?.assignedPhoneNumber.length > 0)
                                                                                    }>Activate</Button>
                                                                            )}
                                                                            {/*<Button className={classes.activeMdn} disabled={true}>Activate</Button>*/}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </div>
                                                        </>}
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <Grid row >
                                                    <Label title="At Location" size={12} />

                                                    <Select
                                                        size="small"
                                                        native
                                                        name="atLocation"
                                                        value={state.atLocation}
                                                        onChange={handleSelectChange}
                                                        placeholder="Select"
                                                        label="Select"
                                                        className={classes.selectBaseInput}
                                                    >
                                                        {atLocationState.map(option =>
                                                            <option value={option.value}>{option.label}</option>
                                                        )
                                                        }
                                                    </Select>

                                                    {/*<InputBaseField*/}
                                                    {/*    name="atLocation"*/}
                                                    {/*    value={state.atLocation}*/}
                                                    {/*    onChange={handleChange}*/}
                                                    {/*    placeholder="At Location"*/}
                                                    {/*    type="text"*/}
                                                    {/*    MaxLength={50}*/}
                                                    {/*/>*/}
                                                    {errorMessages.errorAtLocation && !state.atLocation ? (<FormHelperText style={{ color: "red" }} >
                                                        Please enter location
                                                    </FormHelperText>) : ('')}
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <Grid row >
                                                    <Label title="Collected By" size={12} />
                                                    <InputBaseField
                                                        name="collectedBy"
                                                        value={state.collectedBy}
                                                        onChange={handleChange}
                                                        placeholder="Collected By"
                                                        type="text"
                                                        MaxLength={50}
                                                        useCamelCase={true}
                                                    />
                                                    {errorMessages.errorCollectedBy && !state.collectedBy ? (<FormHelperText style={{ color: "red" }} >
                                                        Please enter collected by
                                                    </FormHelperText>) : ('')}
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row style={{ marginBottom: '5px' }}>
                                                <Label title="Picture Receiving Tablet" size={12} mandatory={true} />
                                                <input type="file" id="fileUploadField" name="pictureReceiving" className={classes.CustomFileSelection} onChange={handleFileChange} accept=".png, .jpg, .jpeg" />
                                                <div className={classes.fileExtenNotif}><i>.png, .jpg, .jpeg files only</i></div>
                                                {errorMessages.errorPictureReceivingPhone && !pictureReceivingPhone.file ? (<FormHelperText style={{ color: "red" }} >
                                                    Please select receiving picture
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>

                                        <Grid container className={pictureReceivingPhone.file || state.receivingPicturePath ? classes.imageBox : ''}>
                                            {pictureReceivingPhone.file || state.receivingPicturePath ?
                                                <>
                                                    <img src={pictureReceivingPhone.file ? pictureReceivingPhone.file : '.' + state.receivingPicturePath} className={classes.previewImg} style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', margin: '5px', width: '325px', height: '204.1px' }} />
                                                </>
                                                : ''
                                            }
                                        </Grid>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <Grid item sm={12} md={12} lg={12} xl={12} className={classes.radioInfo}>
                                                    <FormControl component="fieldset">
                                                        <h4 className={classes.sectionHeadingAccord}>Receiver:</h4>
                                                        <RadioGroup name="receiverType" value={state.receiverType ? state.receiverType : 'Self'} onChange={changeIdentityOption}>
                                                            <FormControlLabel value="Self" control={<Radio />} label="Self" />
                                                            <FormControlLabel value="Guardian" control={<Radio />} label="Parent/Guardian" />
                                                            <FormControlLabel value="SocialWorker" control={<Radio />} label="Social Worker" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>

                                            </Grid>
                                        </Grid>


                                        {state.receiverType == 'Guardian' ?
                                            <>

                                                <div className={classes.guardianMain}>
                                                    <h3 className={classes.sectionHeading}>Parent/Guardian's Proof Of Identity</h3>
                                                    {isData ?
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                {identityGuardianImage.file || state.identityGuardianImagePath ?
                                                                    <>
                                                                        <img src={identityGuardianImage.file ? identityGuardianImage.file : '.' + state.identityGuardianImagePath} width="100%" alt="" />
                                                                    </>
                                                                    : <img src={PreviewPhoto} width="100%" alt="" />
                                                                }
                                                            </Grid>
                                                        </Grid> :
                                                        <>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <Grid row>
                                                                        <Label title="Full Name" size={12} mandatory={true} />
                                                                        <InputBaseField
                                                                            name="guardianFullName"
                                                                            value={state.guardianFullName}
                                                                            onChange={handleChange}
                                                                            placeholder="Full Name"
                                                                            type="text"
                                                                            MaxLength={50}
                                                                            useCamelCase={true}
                                                                        />
                                                                        {errorMessages.errorGuardianFullName && !state.guardianFullName ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please enter full name
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>
                                                                </Grid>

                                                            </Grid>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Last 4 Digit SSN" size={12} mandatory={true} />
                                                                        <InputBaseField
                                                                            name="guardianSSN"
                                                                            value={state.guardianSSN}
                                                                            onChange={handleChange}
                                                                            placeholder="Last 4 Digit SSN"
                                                                            type="text"
                                                                            MaxLength={4}
                                                                            onKeyPress={handleNumberKeyPress}
                                                                            onPaste={(e) => e.preventDefault()}
                                                                            onDrop={(e) => e.preventDefault()}
                                                                        />
                                                                        {errorMessages.errorGuardianSSN && !state.guardianSSN ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please enter last 4 digit SSN
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Date of Birth" size={12} mandatory={true} />

                                                                        <InputBaseField
                                                                            name="guardianDOB"
                                                                            value={state.guardianDOB}
                                                                            onChange={handleChange}
                                                                            placeholder="Date of Birth"
                                                                            type="date"
                                                                            MaxLength={14}
                                                                        />
                                                                        {errorMessages.errorGuardianDOB && !state.guardianDOB ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please enter date of birth
                                                                        </FormHelperText>) : ('')}
                                                                        {errorMessages.errorGuardianDOBFuture && state.guardianDOB > toDayDate() ? (<FormHelperText style={{ color: "red" }} >
                                                                            Date of birth cannt be in future
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>

                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Email Address" size={12} mandatory={true} />

                                                                        <InputBaseField
                                                                            name="guardianEmail"
                                                                            value={state.guardianEmail}
                                                                            onChange={handleChange}
                                                                            placeholder="Email Address"
                                                                            type="text"
                                                                            MaxLength={50}
                                                                        />
                                                                        {errorMessages.errorGuardianEmailAddress && (!state.guardianEmail || !validateEmail(state.guardianEmail)) ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please enter valid email address
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Phone #" size={12} mandatory={true} />

                                                                        <InputBaseField
                                                                            name="guardianPhone"
                                                                            value={state.guardianPhone}
                                                                            onChange={handleGuardianPhoneChange}
                                                                            placeholder="Phone #"
                                                                            type="text"
                                                                            MaxLength={14}
                                                                        />
                                                                        {errorMessages.errorGuardianPhone && (!state.guardianPhone || !validatePhoneNumber(state.guardianPhone)) ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please enter valid phone #
                                                                        </FormHelperText>) : ('')}

                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Document Type" size={12} mandatory={true} />

                                                                        <Select
                                                                            size="small"
                                                                            native
                                                                            name="documentGuardianType"
                                                                            value={state?.documentGuardianType}
                                                                            onChange={handleSelectChange}
                                                                            placeholder="Select"
                                                                            label="Select"
                                                                            className={classes.selectBaseInput}
                                                                        >
                                                                            {documentType.map(option =>
                                                                                <option value={option.value}>{option.label}</option>
                                                                            )
                                                                            }
                                                                        </Select>
                                                                        {errorMessages.errorDocumentGuardianType && !state.documentGuardianType ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please select document type
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>


                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <Grid row>
                                                                        <Label title="Upload Document" size={12} mandatory={true} />
                                                                        <input
                                                                            type="file"
                                                                            id="fileUploadField"
                                                                            name="identityGuardianImage"
                                                                            ref={inputFile}
                                                                            className={classes.CustomFileSelection}
                                                                            onChange={handleFileChange}
                                                                            accept=".png, .jpg, .jpeg" />
                                                                        <div className={classes.fileExtenNotif}><i>.png, .jpg, .jpeg files only</i></div>


                                                                        {errorMessages.errorIdentityGuardianImage && (!identityGuardianImage.file && !state.identityGuardianImagePath) ? (<FormHelperText style={{ color: "red" }} >
                                                                            Please select document
                                                                        </FormHelperText>) : ('')}
                                                                    </Grid>

                                                                </Grid>

                                                            </Grid>
                                                            <Grid container className={identityGuardianImage.file || state.identityGuardianImagePath ? classes.imageBox : ''}>
                                                                {identityGuardianImage.file || state.identityGuardianImagePath ?
                                                                    <>
                                                                        <img src={identityGuardianImage.file ? identityGuardianImage.file : '.' + state.identityGuardianImagePath} className={classes.previewImg} style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', width: '325px', height: '204.1px', margin: '5px' }} />
                                                                    </>
                                                                    : ''
                                                                }
                                                            </Grid>
                                                        </>
                                                    }
                                                </div>

                                            </> : ''


                                        }

                                        {state.receiverType == 'SocialWorker' ?
                                            <>

                                                <div className={classes.guardianMain}>
                                                    {/*<h3 className={classes.sectionHeading}>Social Worker's Proof Of Identity</h3>*/}
                                                    {isData ?
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                {identityGuardianImage.file || state.identityGuardianImagePath ?
                                                                    <>
                                                                        <img src={identityGuardianImage.file ? identityGuardianImage.file : '.' + state.identityGuardianImagePath} width="100%" alt="" />
                                                                    </>
                                                                    : <img src={PreviewPhoto} width="100%" alt="" />
                                                                }
                                                            </Grid>
                                                        </Grid> :
                                                        <>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <Grid row>
                                                                        <Label title="Select Social Worker ~ Agency Name" size={12} />
                                                                        <Select
                                                                            size="small"
                                                                            native
                                                                            name="socialWorkerId"
                                                                            value={state?.socialWorkerId}
                                                                            onChange={handleSocialWorkerSelectChange}
                                                                            placeholder="Select"
                                                                            label="Select"
                                                                            className={classes.selectBaseInput}
                                                                        >
                                                                            {socialWorkers.map(option =>
                                                                                <option value={option.value}>{option.label}</option>
                                                                            )
                                                                            }
                                                                        </Select>
                                                                    </Grid>
                                                                    {errorMessages.errorSelectSocialWorker && (!state.socialWorkerId) ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please select social worker
                                                                    </FormHelperText>) : ('')}

                                                                </Grid>

                                                            </Grid>

                                                            <div className={classes.socialProfileInfo}>
                                                                <Grid container>
                                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                        <Label title="SSN" size={12} />
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                                        <h4>{selectedSocialWorker.ssn}</h4>
                                                                    </Grid>

                                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                        <Label title="Phone #" size={12} />
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                                        <h4>{selectedSocialWorker.phone}</h4>
                                                                    </Grid>


                                                                </Grid>


                                                                <Grid container>
                                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                        <Label title="License #" size={12} />
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                                        <h4>{selectedSocialWorker.agencyLicense}</h4>
                                                                    </Grid>

                                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                        <Label title="Email" size={12} />
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                                        <h4>{selectedSocialWorker.email}</h4>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid container>
                                                                    <Grid container className={classes.imageBox}>
                                                                        {selectedSocialWorker.identityProof ?
                                                                            <>
                                                                                <img src={selectedSocialWorker.identityProof} className={classes.previewImg} style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', width: '325px', height: '204.1px', margin: '5px' }} />
                                                                            </>
                                                                            : ''
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </div>



                                                        </>
                                                    }
                                                </div>

                                            </> : ''


                                        }



                                    </Grid>
                                </Grid>
                            </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                                <Button className={classes.changeBtn} onClick={addNew}>Submit</Button>

                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </>
    )
}

export default withSnackbar(AddProgram);
